import React from "react";
import { useTranslation } from "react-i18next";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { ContactUsMessageWrapper, ContactUsWrapper } from "./ContactUs.styles";
import { ContactUsContent } from "./ContactUsContent";

export const ContactUs = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <ContactUsWrapper data-testid="contactUsTestId">
      {GetTypographyContent({
        content: t("contactUs.form.heading"),
        size: "label",
        textColor: "greyMedium",
        isBold: true,
        isCaps: true,
      })}
      <ContactUsMessageWrapper>
        {GetTypographyContent({
          content: t("contactUs.form.description"),
          size: "medium",
          textColor: "greyMedium",
        })}
      </ContactUsMessageWrapper>
      <ContactUsContent />
    </ContactUsWrapper>
  );
};
